export const FLOWER_IMAGES = {
  NORMAL: "bugo/flower/3_yellow_v2.png",
  LUXURY: "bugo/flower/3_luxury_v2.png",
  LARGE: "bugo/flower/3_large_v2.png",
} as const;
